import { useState } from 'react';
import { useUserState } from '../../hooks/context/useUserState';
import useApiErrorHandling from '../../hooks/useApiErrorHandling';
import { requestForm } from '../requests/requestForm';
import { Form } from '../../types/types';

export const useForm = (datasetId: string) => {
  const {
    state: { token },
  } = useUserState();
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<Error | undefined>(undefined);
  const [data, setData] = useState<Form | undefined>(undefined);
  const handleApiError = useApiErrorHandling();

  const fetch = async (forceHeader?: string) => {
    let form;
    try {
      setIsLoading(true);
      setData(undefined);
      setError(undefined);
      form = await requestForm(datasetId, token, forceHeader);
      setData(form);
      return form;
    } catch (e) {
      if (e instanceof Error) setError(e);
      handleApiError(e, true, (forceHeader) => fetch(forceHeader));
      return null;
    } finally {
      setIsLoading(false);
    }
  };

  return {
    isLoading,
    error,
    data,
    fetch,
  };
};
